const scrollHandler = (y = 0, x = 0) => {
  try {
    window.scroll({ top: y, left: x, behavior: 'smooth' });
  } catch (error) {
    window.scrollTo(y, x);
  }
};

export default scrollHandler;
